export default __webpack_public_path__ + "static/media/A4.8656a226.jpg";